import React, { useState, Fragment, useEffect, useCallback } from 'react';
import { Switch, Button, Divider, Icon, message } from 'antd';
import moment from 'moment';
import _get from 'lodash/get';

import ContactUs from '../../components/ContactUs';
import { BASIC_PLAN_BACKGROUND, CRYPTO_PRO_PLAN_BACKGROUND, FIAT_MASTER_PLAN_BACKGROUND, BLUE_COG_SETTINGS_ICON, VERIFICATION_TICK_ICON, DIY_ICON, DIY_BOOST_ICON } from '../../config/media';
import ConfigWrapper from './style';

export const planData = {
    basic: {
        title: 'Basic',
        description: 'Get started fast with a basic test exchange',
        icon: BASIC_PLAN_BACKGROUND,
        isPopular: false,
        section: [
            {
                title: 'Cloud',
                points: ['Cloud exchange server hosting']
            },
        ],
        services: {
            title: 'Limited features',
            points: ['Theme customization', 'Localization', 'Custom domain', 'Add HollaEx plugins', 'Add custom plugins', 'Download exchange logs', 'Full exchange backup'],
            hideOnMonthly: false,
            hideActive: false
        },
        amount: {
            yearly: 75,
            discount: '25%',
            monthly: 100,
            share: '50%'
        },

    },
    crypto: {
        title: 'Crypto Pro',
        description: 'For those looking to start a crypto-to-crypto exchange business',
        icon: CRYPTO_PRO_PLAN_BACKGROUND,
        isPopular: true,
        section: [
            {
                title: 'Cloud',
                points: ['Cloud exchange server hosting']
            },
        ],
        services: {
            title: 'Full features',
            points: ['Theme customization', 'Localization', 'Custom domain', 'Add HollaEx plugins', 'Add custom plugins', 'Add custom GitHub repo', 'Team management & roles', 'Download exchange logs', 'Full exchange backup', 'Landing page (homepage)', 'Remove HollaEx badge', 'Referral affiliate link', 'Crypto chat box'],
            hideOnMonthly: false,
            hideActive: false
        },
        asset_pairs: {
            title: 'Asset and pairs',
            points: ['One free custom crypto coin & pair']
        },
        amount: {
            yearly: 210,
            discount: '30%',
            monthly: 300,
            share: '25%'
        }
    },
    fiat: {
        title: 'Enterprise',
        description: 'For those that want to have the ultimate experience and unlock all the premium features',
        icon: FIAT_MASTER_PLAN_BACKGROUND,
        isPopular: false,
        section: [
            {
                title: 'Cloud',
                points: ['Cloud exchange server hosting']
            },
        ],
        services: {
            title: 'Full features',
            points: ['Theme customization', 'Localization', 'Custom domain', 'Add HollaEx plugins', 'Add custom plugins', 'Add custom GitHub repo', 'Full management & system', 'Download exchange logs', 'Full exchange backup', 'Landing page (homepage)', 'Remove HollaEx badge', 'Referral affiliate link', 'Crypto chat box'],
            hideOnMonthly: false,
            hideActive: false
        },
        asset_pairs: {
            title: 'Asset and pairs',
            points: ['One free custom crypto coin & pair', 'One free fiat coin & pair']
        },
        integration: {
            title: 'Fiat integration & KYC system',
            points: ["Add fiat bank or payment ramp", "Know your customer (KYC) system"]
        },
        amount: {
            yearly: 850,
            discount: '35%',
            monthly: 1000,
            share: '15%'
        }
    }
};

export const diyPlanData = {
    diy: {
        title: 'Do-it-yourself',
        description: 'For tech savvy people that know their way around a server and can self-host their exchange.',
        isPopular: false,
        icon: DIY_ICON,
        section: [
            {
                title: 'Limited features',
                points: ['Theme customization', 'Localization', 'Add HollaEx plugins', 'Add custom plugins', 'Custom code',]
            },
        ]
    },
    boost: {
        title: 'Boost',
        description: 'For expert exchange operators with technical skills seeking more. Comes fully featured out with reduced revenue sharing, one free custom token and market.',
        isPopular: true,
        icon: DIY_BOOST_ICON,
        services: {
            title: 'Full features',
            points: ['Theme customization', 'Localization', 'Add HollaEx plugins', 'Add custom plugins', 'Custom code', 'Multiple role management system', 'Landing page (homepage)', 'Remove HollaEx badge', 'Crypto chat box', 'Minimum revenue sharing', 'Fiat integration'],
            hideOnMonthly: false,
            hideActive: false
        },
        asset_pairs: {
            title: 'Asset and pairs',
            points: ['One free custom crypto coin & pair']
        }
    }
};

const getTitle = (type, is_paid) => {
    if (type === 'ConfigurePlan' && !is_paid) {
        // return 'Select cloud plan';
    } else if (type === 'ConfigurePlan' && is_paid) {
        return 'Configure plan';
    } else {
        return 'Cloud plan details';
    }
};

const getFooterButton = (type, is_paid, handleClose, handleOpenContact, onCancel) => {
    if (type !== 'ConfigurePlan') {
        return <Button type='primary' className="back-btn" onClick={handleClose}>Back</Button>
    } else if (is_paid) {
        return <div className="d-flex button-wrapper">
            <Button type='primary' className="back-btn" onClick={onCancel}>Back</Button>
            <div className="separator"></div>
            <Button type='primary' className="back-btn" onClick={handleOpenContact}>Contact Us</Button>
        </div>;
    } else {
        return null;
    }
};

const ConfigurePlan = ({ exchange = {}, isMonthly, selectedType, planType, showConfigIcon, handleSelect, handleToggle, handleClose, priceData = {}, onCancel }) => {
    const [isMonth, setPeriod] = useState(isMonthly);
    const [isContact, setContact] = useState(false);
    const isMonthlyLocal = planType !== 'ConfigurePlan'
        ? isMonth
        : isMonthly
    const handleOpenContact = () => {
        handleClose();
        setContact(true);
    };
    const handleContactClose = () => {
        setContact(false);
    };
    const handleOk = (data) => {
        message.success(data);
        handleContactClose();
    };
    const handleError = (error) => {
        message.error(error);
        handleContactClose();
    };
    const isPaid = exchange.is_paid && exchange.expiry && moment().isBefore(moment(exchange.expiry));
    return (
        <ConfigWrapper>
            <div>
                <div className="title">
                    {getTitle(planType, exchange.is_paid)}
                </div>
            </div>
            <div>
                <div style={{ height: '3rem' }}>
                    <div className="switch-wrapper">
                        <div className="d-flex">
                            <div className="switch-content">
                                <span
                                    className={!isMonthlyLocal
                                        ? "switch-label"
                                        : "switch-label label-inactive"
                                    }
                                >
                                    Pay yearly
                                </span>
                                <div className="green-label save-label">(Save up to 35%)</div>
                            </div>
                            <Switch
                                checked={isMonthlyLocal}
                                disabled={
                                    planType === 'ConfigurePlan'
                                    && exchange.is_running
                                    && exchange.is_paid
                                }
                                onChange={(checked) => {
                                    if (planType !== 'ConfigurePlan') {
                                        setPeriod(checked);
                                    } else {
                                        handleToggle(checked);
                                    }
                                }}
                            />
                            <span
                                className={isMonthlyLocal
                                    ? "switch-label"
                                    : "switch-label label-inactive"
                                }
                            >
                                Pay monthly
                            </span>
                        </div>
                    </div>
                </div>
                <div className={exchange.type !== 'DIY' ? "box-container" : "box-container inc-padding"}>
                    <div className="content-wrapper">
                        {exchange.type !== 'DIY'
                            ?
                            Object.keys(priceData).map((key, index) => {
                                if (key !== 'boost') {
                                    return (
                                        <PlanStructure
                                            key={index}
                                            type={key}
                                            exchange={exchange}
                                            isMonthly={isMonthlyLocal}
                                            planType={planType}
                                            showConfigIcon={showConfigIcon}
                                            selectedType={selectedType}
                                            handleSelect={handleSelect}
                                            priceData={priceData}
                                        />
                                    )
                                } else {
                                    return null;
                                }
                            })
                            :
                            Object.keys(diyPlanData).map((key, index) => {
                                return (
                                    <DIYPlanStructure
                                        key={index}
                                        type={key}
                                        exchange={exchange}
                                        isMonthly={isMonthlyLocal}
                                        planType={planType}
                                        showConfigIcon={showConfigIcon}
                                        selectedType={selectedType}
                                        handleSelect={handleSelect}
                                        priceData={priceData}
                                    />
                                )
                            })
                        }
                    </div>
                </div>
            </div>
            {planType === 'ConfigurePlan'
                && isPaid
                ? (<div className="footer footer-paid">
                    <Icon type="info-circle" />
                    Contact us to configure plan.
                </div>)
                : (<div className="footer">
                    {/* {exchange.type !== 'Cloud'
                        ?
                        <div>
                            <div>
                                *A donation towards the HollaEx network is required for new custom coin and trading pair activation
                            </div>
                        </div>
                        :
                        <div>
                            *A donation towards the HollaEx network is required for new custom coin and trading pair activation
                        </div>
                    }
                    <div>
                        *Custom exchange code and technical support are not included in cloud plans and are paid separately
                    </div> */}
                </div>)
            }
            <div>
                {getFooterButton(planType, isPaid, handleClose, handleOpenContact, onCancel)}
            </div>
            {isContact
                ? <ContactUs
                    visible={isContact}
                    defaultType="Other"
                    handleOk={handleOk}
                    handleError={handleError}
                    handleCancel={handleContactClose}
                />
                : null
            }
        </ConfigWrapper>
    )
}

export default ConfigurePlan;

export const DIYPlanStructure = ({
    exchange,
    type,
    isMonthly,
    planType,
    showConfigIcon = false,
    handleSelect,
    priceData,
    selectedType
}) => {
    let currentPlan = diyPlanData[type];
    let planPriceData = priceData[type];

    return (
        <div
            className={
                (selectedType === type || planType !== 'ConfigurePlan')
                    ? "selected-popular-container popular-container"
                    : "popular-container"
            }
        >
            <div className="popular-label">
                {_get(currentPlan, 'isPopular') && !showConfigIcon
                    ? <div className="popular-header">MOST POPULAR</div>
                    : null
                }
            </div>
            <div
                className={
                    selectedType === type || planType !== 'ConfigurePlan'
                        ? "selected-content-wrapper"
                        : "content-wrapper"
                }
            >
                <div className="content">
                    <div className="flex-space-wrapper">
                        <div>
                            <div className={type !== 'boost' ? "header_section" : "header_section blue-bg"}>
                                <div className='diy-wrapper'>
                                    <img src={_get(currentPlan, 'icon')} className="diy-icon" alt="status" />
                                    <div className="title">
                                        {_get(currentPlan, 'title')}
                                    </div>
                                </div>
                                <div className="small-text">
                                    {_get(currentPlan, 'description')}
                                </div>
                            </div>
                            <div className='info-link-content'>
                                <a href='https://www.hollaex.com/pricing?type=diy' target="_blank" rel="noopener noreferrer">
                                    Learn more
                                </a>
                            </div>
                        </div>
                        <div className="center-wrapper">
                            <Divider />
                            {type === 'boost'
                                ?
                                <div className="amount-wrapper">
                                    <div>
                                        {isMonthly
                                            ?
                                            <div className="amount-wrapper">
                                                <div className="amount-label">${_get(planPriceData, 'month.price')}</div>
                                                <div className="small-text">per month</div>
                                            </div>
                                            :
                                            <div className="amount-wrapper">
                                                <div>
                                                    <div className="amount-label">${_get(planPriceData, 'year.price')}</div>
                                                    <div className="small-text">per year</div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                                :
                                <div className="amount-wrapper">
                                    <div className="amount-label">Free</div>
                                </div>
                            }
                            <Divider />

                            <div className="select-btn">
                                {(planType === 'ConfigurePlan'
                                    && !exchange.is_paid)
                                    ? <div className="d-flex flex-direction-column">
                                        {selectedType === type
                                            ? <Fragment>
                                                <img src={VERIFICATION_TICK_ICON} className="requirement-icon" alt="status" />
                                                <div className="selected-status">SELECTED</div>
                                            </Fragment>
                                            : <Fragment>
                                                <div className="de-select-status" onClick={() => handleSelect(type)}></div>
                                                <div className="de-select-status-txt">Select</div>
                                            </Fragment>
                                        }
                                    </div>
                                    : null
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export const PlanStructure = ({
    exchange,
    type,
    isMonthly,
    planType,
    showConfigIcon = false,
    handleConfigPlan,
    handleSelect,
    priceData,
    selectedType
}) => {
    let currentPlan = planData[type];
    let planPriceData = priceData[type];

    const handleSelectCallback = useCallback((value) => {
        handleSelect(value);
    }, [handleSelect]);

    useEffect(() => {
        // if (isMonthly && selectedType === 'fiat') {
        //     handleSelectCallback('basic');
        // }
    }, [planPriceData.month.price, isMonthly, selectedType, handleSelectCallback]);
    return (
        <div
            className={
                (selectedType === type || planType !== 'ConfigurePlan')
                    ? "selected-popular-container popular-container"
                    : "popular-container"
            }
        >
            <div className="popular-label">
                {!showConfigIcon
                    ? <div className={`popular-header-${type}`}>{type === "crypto" ? "MOST POPULAR" : ""}</div>
                    : null
                }
            </div>
            <div
                className={
                    selectedType === type || planType !== 'ConfigurePlan'
                        ? "selected-content-wrapper"
                        : "content-wrapper"
                }
            >
                <div className="content">
                    {showConfigIcon
                        ? <img
                            src={BLUE_COG_SETTINGS_ICON}
                            className="cloud-plan-img"
                            alt="plan"
                            onClick={() => handleConfigPlan('ConfigurePlan')}
                        />
                        : null
                    }
                    <div className="flex-space-wrapper">
                        <div>
                            <div className="plan-img" style={{ backgroundImage: `url(${_get(currentPlan, 'icon')})` }}>
                                <div className="title">
                                    {_get(currentPlan, 'title')}
                                </div>
                                <div className="small-text">
                                    {_get(currentPlan, 'description')}
                                </div>
                                <div className='info-link-content'>
                                    <a href='https://www.hollaex.com/pricing' target="_blank" rel="noopener noreferrer">
                                        Learn more
                                    </a>
                                </div>
                                {/* <img
                                src={currentPlan.icon}
                                alt="Basic coin drop"
                            /> */}
                            </div>
                            {/* <div className="center-wrapper">
                                <Divider />
                            </div> */}
                        </div>
                        <div className="center-wrapper">
                            <Divider />
                            <div>
                                {isMonthly
                                    ?
                                    (type !== 'fiat'
                                        ?
                                        <div className="amount-wrapper">
                                            <div className="amount-label">${_get(planPriceData, 'month.price')}</div>
                                            <div className="small-text">per month</div>
                                        </div>
                                        :
                                        <div className="amount-wrapper">
                                            <div className="amount-label">${_get(planPriceData, 'month.price')}</div>
                                            <div className="small-text">per quarter</div>
                                        </div>)
                                    :
                                    <div className="amount-wrapper">
                                        <div>
                                            <div className="amount-label">${_get(planPriceData, 'year.price')}</div>
                                            <div className="small-text">per year</div>
                                        </div>
                                        {/* <div className="green-label save-annual">Save {currentPlan.amount.discount} annually</div> */}
                                    </div>
                                }
                            </div>
                            <Divider />

                            <div className="select-btn">
                                {(planType === 'ConfigurePlan'
                                    && !exchange.is_paid)
                                    ? <div className="d-flex flex-direction-column">
                                        {selectedType === type
                                            ? <Fragment>
                                                <img src={VERIFICATION_TICK_ICON} className="requirement-icon" alt="status" />
                                                {/* <Button
                                                    type='primary'
                                                    disabled={exchange.is_running}
                                                    onClick={() => handleSelect(type)}
                                                > */}
                                                <div className="selected-status">SELECTED</div>
                                            </Fragment>
                                            : <Fragment>
                                                <div className="de-select-status" onClick={() => handleSelect(type)}></div>
                                                {/* {(!isMonthly || planPriceData.month.price)
                                                    ? <div className="de-select-status" onClick={() => handleSelect(type)}></div>
                                                    : <div className="de-select-status no-cursor" ></div>
                                                } */}
                                                <div className="de-select-status-txt">Select</div>
                                            </Fragment>
                                        }
                                    </div>
                                    : null
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}